export const IS_AGENT_ADMIN     = 1;
export const IS_NOT_AGENT_ADMIN = 0;

export class HistorySearchModel {
    public page: number;
    public limit: number;
    public agentAdmin: number;
}
